import { createContext, useContext, useEffect, useState } from 'react'
import { api, setToken, clearToken } from '../lib/api'

const Ctx = createContext({})
export const useAuth = () => useContext(Ctx)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('adops_token')
    if (token) {
      api.me().then(u => { setUser(u); setLoading(false) })
        .catch(() => { clearToken(); setLoading(false) })
    } else setLoading(false)
  }, [])

  async function signIn(email, password) {
    const { token, user } = await api.login(email, password)
    setToken(token)
    setUser(user)
    return user
  }

  function signOut() {
    clearToken()
    setUser(null)
  }

  function refreshUser() {
    return api.me().then(setUser)
  }

  return (
    <Ctx.Provider value={{ user, loading, signIn, signOut, refreshUser }}>
      {children}
    </Ctx.Provider>
  )
}
